import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Helper } from '@usimweb/core/services';

@Component({
    selector: 'app-results-chart',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './results-chart.component.html',
    styleUrls: ['./results-chart.component.scss'],
    standalone: false
})
export class ResultsChartComponent implements OnInit, OnChanges {
  @Input() data: any[] = [];

  @Input() layout: any = {};

  @Output() selectedPlotTypeEvent: EventEmitter<any> = new EventEmitter<any>();

  public plotData: any[] = [];
  public plotLayout: any = {};

  public plotTypes = [
    { key: 'filling', value: 'Filling' },
    { key: 'mass', value: 'Mass' },
    { key: 'density', value: 'Density' },
    { key: 'pressure', value: 'Pressure' },
    { key: 'temperature', value: 'Temperature' },
    { key: 'viscosity', value: 'Viscosity' },
  ];

  ngOnInit(): void {
    this.plotData = Helper.Array.deepCopy(this.data);
    setTimeout(() => {
      this.plotLayout = Helper.Array.deepCopy(this.layout);
      this.plotLayout.height = 500;
      this.plotLayout.width = 850;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && this.data) {
      this.plotData = [];
      this.plotLayout = [];
      // FIXME different data input like in on init
      if (this.data[0].data) {
        this.plotData = Helper.Array.deepCopy(this.data[0].data);
        this.plotLayout = Helper.Array.deepCopy(this.data[0].layout);
      } else {
        this.plotData = Helper.Array.deepCopy(this.data);
        this.plotLayout = Helper.Array.deepCopy(this.layout);
      }

      this.plotLayout.height = 500;
      this.plotLayout.width = 850;
    }
  }

  public selectedPlotType(event: string) {
    this.selectedPlotTypeEvent.emit(event);
  }
}
